<template>
  <basic-container>
    <el-form
      id="paydetailquery"
      ref="searchForm"
      :model="query"
      label-width="100px"
      margin-top="0"
      :rules="rules"
    >
      <el-row :gutter="0">
        <el-col :span="6">
          <!-- <el-form-item label="速记码" prop="shortCode">
            <el-input
              v-model="query.shortCode"
              @input="propertyFilter()"
              placeholder="速记码"
            ></el-input>
          </el-form-item> -->

          <el-form-item label="小区分组" prop="communityGroup">

            <el-select style="width: 100%" v-model="query.communityGroup" @change="communityGroupChangeHandler">
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="小区名称" prop="propertyId">

                <avue-input-tree
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all
                    v-model="query.propertyId"
                    placeholder="请选择小区"
                    type="select"
                    @change="communityIdChange"
                    :dic="allPropertyListCopy"
                >
                </avue-input-tree>
            <!-- <el-select v-model="query.propertyId" placeholder="请选择小区" style="width: 100%">
              <el-option
                v-for="item in allPropertyListCopy"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="房号" prop="payType">
            <avue-input-tree
                    node-key="id"
                    :props="roomDefaultProps"
                    default-expand-all
                    v-model="query.roomId"
                    placeholder="请选择房号"
                    type="select"

                    :dic="allRoomList"
                >
                </avue-input-tree>

          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="支付方式" prop="payType">
            <el-select v-model="query.payType" placeholder="全部" style="width: 100%" clearable>
              <el-option
                v-for="item in allPayTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收费日期 从" prop="dateRange">
            <el-date-picker
              style="width:42%;"
              v-model="query.dateFrom"
              type="date"
              value-format="yyyy-MM-dd 00:00:00.000"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.dateTo"
              type="date"
              value-format="yyyy-MM-dd 23:59:59.999"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="缴费人" prop="householdName">
            <el-input v-model="query.householdName" placeholder="缴费人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发票号" prop="feeInvoiceNo">
            <el-input v-model="query.feeInvoiceNo" placeholder="发票号" class="redStyle"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="缴费来源" prop="payCost">
            <!-- <el-input v-model="query.payCost" placeholder="缴费来源"></el-input> -->
             <el-select v-model="query.payCost" placeholder="全部" style="width: 100%" clearable>
              <el-option
                v-for="item in allPayCostList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="应缴金额" prop="shouldAmountSum">
            <el-input :value="shouldAmountSum" :disabled="true" class="redStyle"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="实收金额" prop="payAmountSum">
            <el-input :value="payAmountSum" :disabled="true" class="redStyle"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收据号" prop="invoiceNo">
            <el-input v-model="query.invoiceNo" placeholder="收据号" class="redStyle"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="text-align:right;">
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            @click.prevent="submitSearchForm"
            >搜索</el-button
          >
          <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      @tree-load="treeLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="exportExcel()"
        v-if="permissionList.paydetailquery_export"
          >导 出
        </el-button>
      </template>
      <template slot="shouldAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.shouldAmount) }}</span>
      </template>
      <template slot="delayAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.delayAmount) }}</span>
      </template>
      <template slot="derateAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.derateAmount) }}</span>
      </template>
      <template slot="accountpayAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.accountpayAmount) }}</span>
      </template>
      <template slot="couponAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.couponAmount) }}</span>
      </template>
      <template slot="depositAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.depositAmount) }}</span>
      </template>
      <template slot="payAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.payAmount) }}</span>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-printer"
          v-if="(scope.row.invoicingFlag == 0 || scope.row.invoicingFlag == 2 || scope.row.invoicingFlag == 3)
          && permissionList.dayin && scope.row.payStatus <= 1 && scope.row.payStatus >= 0 && scope.row.payStatus != null"
          @click="printBill(scope.row)"
          >收据打印
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-operation"
          v-if="permissionList.tuikuan&&scope.row.payStatus<=1&&scope.row.payStatus>=0&&scope.row.payStatus!=null
          && (scope.row.invoicingFlag == 0 || scope.row.invoicingFlag == 1
            || scope.row.invoicingFlag == 2 || scope.row.invoicingFlag == 3 || scope.row.invoicingFlag == 4)"
          @click="feeReturnApply(scope.row)"
          >退款申请
        </el-button>
<!--        <el-button-->
<!--          type="text"-->
<!--          size="small"-->
<!--          icon="el-icon-s-operation"-->
<!--          v-if="scope.row.invoicingFlag==0&&permissionList.kaifapiao&&scope.row.payStatus<=1&&scope.row.payStatus>=0&&scope.row.payStatus!=null"-->
<!--          @click="openApplyInvioceDialog(scope.row)"-->
<!--          >发票开具-->
<!--        </el-button>-->
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-operation"
          v-if="(scope.row.invoicingFlag == 0 || scope.row.invoicingFlag == 2 || scope.row.invoicingFlag == 3)
            && scope.row.payStatus <= 1 && permissionList.kaifapiao
            && scope.row.payStatus >= 0 && scope.row.payStatus != null && scope.row.invoiceNo == ''"
          @click="newOpenApplyInvoiceDialog(scope.row)"
        >发票开具
        </el-button>
<!--        <el-button-->
<!--          type="text"-->
<!--          size="small"-->
<!--          icon="el-icon-view"-->
<!--          v-if="scope.row.invoicingFlag==0&&permissionList.rizhi"-->
<!--          @click="openInvoicePrintJournal(scope.row)"-->
<!--        >打印日志-->
<!--        </el-button>-->
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permissionList.rizhi"
          @click="openInvoiceOperateLog(scope.row)"
        >操作日志
        </el-button>
        <el-button type="text" size="small" v-if="permissionList.xiazai && scope.row.invoicingFlag == 1" @click="downloadFile(scope.row)">
          下载
        </el-button>
        <!-- <div v-if="!showInvoiceApplyBtn(scope.row)"
             style="color: red"
        >
          已开电子发票
        </div> -->
      </template>
      <template slot="feeSort" slot-scope="scope">
        <el-tag>{{ feeSortShow(scope.row) }}</el-tag>
      </template>

      <template slot="invoicingFlag" slot-scope="scope">
        <div style="color: #409EFF;cursor: pointer;" @click="openTaxInvoiceRecord(scope.row)">
          <span>{{invoiceStatusList.find(ele => ele.dictKey == scope.row.invoicingFlag).dictValue}}</span>
        </div>
      </template>

      <template slot="feeInvoiceNo" slot-scope="scope">
        <div style="color: #409EFF;cursor: pointer;" @click="openTaxInvoiceDetail(scope.row)">
          <span>{{ scope.row.feeInvoiceNo }}</span>
        </div>
      </template>
    </avue-crud>
    <printPreview ref="printPreview" @saveF5="onLoad"></printPreview>
    <fee-return-apply-dialog
      ref="feeReturnApplyDialog"
      @closeApplyForm="onLoad"
    ></fee-return-apply-dialog>
    <InvoiceApplyDialog ref="invoiceApplyDialog" @submit="applyForInvoice" />
    <invoicePrintJournal  v-if="invoicePrintJournalVisible" :visible.sync="invoicePrintJournalVisible" :feePayId="invoicePrintJournalId"></invoicePrintJournal>
    <TaxInvoiceApplyDialog ref="taxInvoiceApplyDialog" @close="onLoad" />
    <InvoiceDownloadDialog ref="InvoiceDownloadDialog" />
    <InvoiceOperateLog
      v-if="invoiceOperateVisible"
      :visible.sync="invoiceOperateVisible"
      @close="invoiceOperateVisible = false"
      :feePayId="invoiceOperateSearchId">
    </InvoiceOperateLog>

    <TaxInvoiceRecordPage
      v-if="invoiceRecordVisible"
      :visible.sync="invoiceRecordVisible"
      @close="invoiceRecordVisible = false"
      :communityId="this.query.propertyId"
      :feePayId="invoiceRecordSearchId">
    </TaxInvoiceRecordPage>

    <el-dialog
      title="发票查看"
      width="60%"
      v-if="showDetail"
      :visible.sync="showDetail"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <TaxInvoiceDetail
        v-if="showDetail"
        :searchObj="searchDetailObj"
        @close="closeDetail"
      ></TaxInvoiceDetail>
    </el-dialog>
  </basic-container>

</template>

<script>
import {
  add,
  getDetail,
  getTreeExcel,
  payPageTree,
  payPageChildren,
  remove,
  update,
  beforeOpenApply,
  getAllRoomByCommunityId
} from '@/api/v4ward/paylist/feepaylist';
import { invoiceIssuePositive } from '@/api/v4ward/payrecord/index';
import { mapGetters } from 'vuex';
import { getOptionNode } from '../../../api/v4ward/property/baseproperty';
import { getDictionary ,getCommunityGroupList } from '../../../api/common';
    import _ from 'lodash';
import printPreview from '@/views/v4ward/pay/printdialog/printPreview';
import feeReturnApplyDialog from '@/views/v4ward/feereturn/feereturn-apply';
import InvoiceApplyDialog from './invoice-apply-dialog';
import TaxInvoiceApplyDialog from '../digitaltickets/compoents/tax-invoice-apply-dialog';
import InvoiceDownloadDialog from '../digitaltickets/compoents/invoice-download-dialog';
import InvoiceOperateLog from './compoents/invoice-operate-log';
import TaxInvoiceRecordPage from './compoents/tax-invoice-record-page';
import  invoicePrintJournal from  './invoice-print-journal.vue'
import TaxInvoiceDetail from '../digitaltickets/taxinvoicerecord/compoents/TaxInvoiceDetail.vue';

export default {
  components: {
    printPreview,
    feeReturnApplyDialog,
    InvoiceApplyDialog,
    invoicePrintJournal,
    TaxInvoiceApplyDialog,
    InvoiceDownloadDialog,
    InvoiceOperateLog,
    TaxInvoiceDetail,
    TaxInvoiceRecordPage
  },
  data() {
    return {
      downloading:false,
      invoiceStatusList:[
        {
          dictValue:"未开",
          dictKey:0
        },
        {
          dictValue:"已开票",
          dictKey:1
        },
        {
          dictValue:"开票失败",
          dictKey:2
        },
        {
          dictValue:"已红冲",
          dictKey:3
        },
        {
          dictValue:"开票中",
          dictKey:4
        },
        {
          dictValue:"未开",
          dictKey:-1
        },
      ],
      allRoomList:[],
        defaultProps:{
            children: 'children',
            label: 'title',
        value: 'id',
        },
        roomDefaultProps:{
          label: 'roomName',
        value: 'roomId',
        },

      invoiceRecordSearchId:'',
      invoiceRecordVisible:false,

      invoiceOperateSearchId:'',
      invoiceOperateVisible:false,
      showDetail:false,
      searchDetailObj:{},
      communityGroupList:[],
      invoicePrintJournalId:'',
      invoicePrintJournalVisible:false,
      invoicePrintJournalData:[],
      //如果已经根据速记码查询过了小区信息则为true
      propertyIsQuery: false,
      payAmountSum: '',
      shouldAmountSum: '',
      dateRange: [],
      allPayTypeList: [],
      allPropertyList: [],
      allPropertyListCopy: [],
      allSortTypeList: [],
      allPayCostList: [],
      payCostList:[],
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      propertyName: '',
      form: {},
      query: {
        communityGroup:"",
        shortCode: '',
        propertyId: '',
        feeSort: '',
        householdName: '',
        invoiceNo: '',
        payType: '',
        payCost:'',
        dateFrom:'',
        dateTo:'',
        roomId:'',
        feeInvoiceNo:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        // height: 'auto',
        lazy: true,
        rowKey: 'id',
        calcHeight: 30,
        tip: false,
        border: true,
        viewBtn: false,
        excelBtn: false,
        selection: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '地址',
            prop: 'roomName',
            width: 180,
          },
          {
            label: '缴费人',
            prop: 'householdName',
          },
          {
            label: '费项名称',
            prop: 'feeSort',
            slot: true,
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '滞纳金',
            prop: 'delayAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '减免金额',
            prop: 'derateAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '账户抵扣金额',
            prop: 'accountpayAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '优惠券抵扣金额',
            prop: 'couponAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '押金抵扣金额',
            prop: 'depositAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '收款人',
            prop: 'cashierName',
          },
          {
            label: '收据号',
            prop: 'invoiceNo',
          },

          {
            label: '缴费来源',
            prop: 'payCost',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_cost',
            dataType: 'number',
          },
          // {
          //   label: '收费周期',
          //   prop: 'billcycleNo',
          // },
          // {
          //   label: '收费摘要',
          //   prop: 'payRemark',
          // },
          {
            label:'支付状态',
            prop: 'payStatus',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            dicData:[
            {
              dictKey:0,
              dictValue:'未支付',
            },
            {
              dictKey:1,
              dictValue:'已支付',
            },
            {
              dictKey:2,
              dictValue:'部分退款',
            },
            {
              dictKey:3,
              dictValue:"全部退款",
            },
            {
              dictKey:9,
              dictValue:'已关闭',
            },
            {
              dictValue:"",
              dictKey:-1
            },
            ]
          },

          {
            label: '发票状态',
            prop: 'invoicingFlag',
            slot: true,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
           dicData:[],
            dataType: 'number',
          },
          {
            label: '发票号',
            prop: 'feeInvoiceNo',
            slot: true,
            width: 160,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basebankchangeinfo_add, false),
        viewBtn: this.vaildData(this.permission.basebankchangeinfo_view, false),
        delBtn: this.vaildData(this.permission.basebankchangeinfo_delete, false),
        editBtn: this.vaildData(this.permission.basebankchangeinfo_edit, false),

        tuikuan: this.vaildData(this.permission.paydetailquery_tuikuan, false),
        dayin: this.vaildData(this.permission.paydetailquery_dayin, false),
        rizhi: this.vaildData(this.permission.paydetailquery_rizhi, false),
        kaifapiao: this.vaildData(this.permission.paydetailquery_kaifapiao, false),
        xiazai: this.vaildData(this.permission.paydetailquery_xiazai, false),
        paydetailquery_export: this.vaildData(this.permission.paydetailquery_export, false),

      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
watch:{
  "query.propertyId"(){
      this.query.roomId=""

      if(this.query.propertyId==""){
        this.allRoomList =[]

      }else{
        getAllRoomByCommunityId({communityId:this.query.propertyId}).then(res=>{
          this.allRoomList =res.data
        })


      }
    }
},
  created() {
    this.findObject(this.option.column, 'invoicingFlag').dicData = this.invoiceStatusList;
    this.initDefaultDateRange();
    // this.initPropertyList();
    this.initSortTypeList();
    this.initPayTypeList();
    this.initPayCostList();
    let this_ = this;
      getCommunityGroupList().then((res)=>{
        this.communityGroupList = res.data;
        this.query.communityGroup = res.data[0].dictKey;
          this.initPropertyList((data)=>{
              this.query.propertyId = data[0].id;
              this.query = _.cloneDeep(this_.query);
              this.onLoad();
          });
      });
  },
  methods: {
    downloadFile(row) {
      let invoiceData = {
        invoiceNo: row.feeInvoiceNo,
      };
      this.$refs.InvoiceDownloadDialog.openDialog(invoiceData);
    },
    openTaxInvoiceRecord(row){
      this.invoiceRecordVisible = true;
      this.invoiceRecordSearchId = row.id;
    },
    openTaxInvoiceDetail(row){
      this.searchDetailObj = {invoiceNo:row.feeInvoiceNo};
      this.showDetail = true;
    },
    closeDetail(){
      this.searchDetailObj = {};
      this.showDetail = false;
    },
    newOpenApplyInvoiceDialog(row) {
      let invoiceData = Object.assign({}, row);
      invoiceData.businessType = '11';
      invoiceData.communityId = this.query.propertyId;
      invoiceData.feePayId = row.id;
      console.log('row<<<<<<', row);
      console.log('invoiceData>>>>>>>', invoiceData);
      this.$refs.taxInvoiceApplyDialog.openDialog(invoiceData);
    },
        communityGroupChangeHandler(val){
          let this_ = this;
          this.allPropertyListCopy = [];
            this.initPropertyList((data)=>{
              this.query.propertyId = data[0].id;
              this.query = _.cloneDeep(this_.query);
              // this.onLoad();
            });
        },
    openInvoicePrintJournal(row){
      this.invoicePrintJournalId = row.id
      this.invoicePrintJournalVisible = true
    },
    openInvoiceOperateLog(row){
      this.invoiceOperateSearchId = row.id;
      console.log("打开操作日志");
      this.invoiceOperateVisible = true;
    },
    //打开申请发票弹窗
    openApplyInvioceDialog(row) {
      console.log('row');
      console.log(row);
      this.$refs.invoiceApplyDialog.openDialog(row);
    },
    //申请发票
    applyForInvoice(data, cb) {
      let loading = this.$loading();
      invoiceIssuePositive(data)
        .then((res) => {
          loading.close();
          this.$message({
            message: res.msg,
            type: res.success ? 'success' : 'error',
          });
          cb();
          this.onLoad();
        })
        .catch((res) => {
          loading.close();
          console.log('res==>', res);
          cb();
        });
    },
    treeLoad(tree, treeNode, resolve) {
      console.log('tree', tree);
      console.log('treeNode', treeNode);
      payPageChildren(tree.id).then((data) => {
        console.log(data.data);
        resolve(data.data);
      });
    },
    showAuditBtn(feeSortCount) {
      return feeSortCount !== '' && this.vaildData(this.permission.feereturn_apply, false);
    },
    showInvoiceApplyBtn(row) {
      let notApplied = row.invoicingFlag == 0;
      let rightStatus = row.payStatus == 1;
      // notApplied = true;
      return notApplied && rightStatus && this.vaildData(this.permission.invoice_apply, false);
    },
    //监听速记码变化过滤房产信息
    propertyFilter() {
      let val = this.query.shortCode;
      if (val) {
        //速记码存在,改变小区过滤状态，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList.filter(function (item) {
          return item.shortCode.indexOf(val) > -1;
        });
        this.propertyIsQuery = true;
      } else {
        //val为空时，还原数组,将过滤状态还原，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList;
        this.propertyIsQuery = false;
        this.query.propertyId = '';
      }
      if (this.allPropertyListCopy.length > 0){
        // this.query.propertyId = this.allPropertyListCopy[0].id;
        this.query = Object.assign({},this.query,{propertyId:this.allPropertyListCopy[0].id});
      }
      else this.query.propertyId = '';
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.tool.clearObject(this.query,"communityGroup");
      this.initDefaultDateRange()
      this.propertyFilter();
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    onLoad(page) {

      if (this.propertyIsQuery && !this.query.propertyId) {
        if (this.allPropertyListCopy.length > 0) {
          this.query.propertyId = this.allPropertyListCopy[0].id;
        } else {
          this.$message.error('未查询到任何小区，请重新输入速记码!');
          return;
        }
      }
      page = page || this.page;
      this.loading = true;
      if (!this.query.propertyId) {
        getOptionNode({}).then((data) => {
          this.query.propertyId = data.data[0].id;
          payPageTree(
            Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
          ).then(({ data }) => {
            this.page.total = data.ipageQuery.total;
            this.data = data.ipageQuery.records;
            this.shouldAmountSum = data.shouldAmountSum;
            this.payAmountSum = data.payAmountSum;
            this.loading = false;
            this.selectionClear();
          });
        });
        return;
      }
      payPageTree(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
      ).then(({ data }) => {
        this.page.total = data.ipageQuery.total;
        this.data = data.ipageQuery.records;
        this.shouldAmountSum = data.shouldAmountSum;
        this.payAmountSum = data.payAmountSum;
        this.loading = false;
        this.selectionClear();
      });
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    initDefaultDateRange() {
      this.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      // this.query.dateFrom=this.getCurrentMonthFirst() + " 00:00:00.000";
      // this.query.dateTo=this.getCurrentMonthLast()+" 23:59:59.999";
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    initPropertyList(cb) {
      let this_ = this;
      getOptionNode({communityGroup:this_.query.communityGroup}).then((data) => {
        if (this.propertyIsQuery) {
          this.allPropertyList = data.data;
        } else {
          this.allPropertyList = data.data;
          this.allPropertyListCopy = data.data;
        }
        cb(data.data);
      });
    },

    initSortTypeList: function () {
      getDictionary('fee_sort').then((data) => {
        this.allSortTypeList = data.data;
      });
    },

    initPayTypeList: function () {
      getDictionary('pay_type').then((data) => {
        this.allPayTypeList = data.data;
      });
    },

    initPayCostList: function () {
      getDictionary('pay_cost').then((data) => {
        console.log('data==>',data);
        this.allPayCostList = data.data;
      });
    },
    //导出
    exportExcel() {
      this.$confirm('确定导出所有数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        getTreeExcel(Object.assign({}, this.query)).then(({ data }) => {
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '地址',
              '缴费人',
              '费项',
              '收费时间',
              '应收金额',
              '滞纳金',
              '减免金额',
              '账户抵扣金额',
              '优惠券抵扣金额',
              '收费金额',
              '支付方式',
              '收款人',
              '收据号',
              '收费摘要',
              '缴费来源',
            ]; // 导出excel 的标题
            const filterVal = [
              'roomName',
              'householdName',
              'feeSortCount',
              'payTime',
              'shouldAmount',
              'delayAmount',
              'derateAmount',
              'accountpayAmount',
              'couponAmount',
              'payAmount',
              'payType',
              'cashierName',
              'invoiceNo',
              'payRemark',
              'payCost',
            ]; // 每个标题对应的字段

            const list = (data || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                roomName: item.roomName,
                householdName: item.householdName,
                feeSortCount: item.feeSortCount,
                payTime: this.dayjs(item.payTime).format('YYYY-MM-DD HH:mm:ss'),
                shouldAmount: item.shouldAmount,
                delayAmount: item.delayAmount,
                accountpayAmount: item.accountpayAmount,
                derateAmount: item.derateAmount,
                couponAmount: item.couponAmount,
                payAmount: item.payAmount,
                payType: this.payTypeToPayTypeName(item.payType),
                cashierName: item.cashierName,
                invoiceNo: item.invoiceNo,
                payRemark: item.payRemark,
                payCost: this.payCostToName(item.payCost),
              };
            });

            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename: '收费明细' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            } else {
              this.$message.error('暂无有效数据');
            }
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    payTypeToPayTypeName(payType) {
      var payTypeName = '';
      this.allPayTypeList.forEach(function (value, index, array) {
        if (value.dictKey == payType) {
          payTypeName = value.dictValue;
          return;
        }
      });
      return payTypeName;
    },
    feeSortShow(row) {
      if (row.feeSortCount) return row.feeSortCount;
      else if (row.feeSort) return this.feeSortToName(row.feeSort);
    },
    feeSortToName(feeSort) {
      var feeSortName = '';
      this.allSortTypeList.forEach(function (value, index, array) {
        if (value.dictKey == feeSort) {
          feeSortName = value.dictValue;
          return;
        }
      });
      return feeSortName;
    },
    payCostToName(payCost) {
      var payCostName = '';
      this.allPayCostList.forEach(function (value, index, array) {
        if (value.dictKey == payCost) {
          payCostName = value.dictValue;
          return;
        }
      });
      return payCostName;
    },
    printBill(row) {
      this.$refs.printPreview.openPayChargePrintPreDialog(row.payBillNo);
    },
    feeReturnApply(row) {
      if (row.invoicingFlag == 1) {
        this.$alert('此收费记录已经开具了发票，需要将发票红冲后才可进行退款操作！', '提示', {
          confirmButtonText: '确定',
          callback: () => {},
        });
        return;
      }
      if (row.invoicingFlag == 4) {
        this.$alert('此收费记录正在开具发票，请等待操作完成！', '提示', {
          confirmButtonText: '确定',
          callback: () => {},
        });
        return;
      }
      beforeOpenApply(row.id).then((res) => {
        var data = res.data;
        if (data.code === 201) {
          this.$refs.feeReturnApplyDialog.openDialogForm('退款申请', row.id);
        } else {
          this.$alert(data.msg, '提示信息', {
            confirmButtonText: '确定',
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}

.el-dialog__body .el-card__body {
  padding: 0;
}

.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 5px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>
